/**
 * Diamond Filter Widget
 * 獨立的鑽石篩選器功能
 * 可用於任何頁面
 */

class DiamondFilter {
  constructor() {
    console.log('🔍 Diamond Filter initialized');

    // 從 DOM 讀取默認視圖設定
    const activeToggle = document.querySelector('.view-toggle-btn.active');
    this.currentView = activeToggle ? activeToggle.dataset.view : 'grid';
    console.log('🔍 Initial view:', this.currentView);

    this.init();
  }

  init() {
    console.log('🔍 Diamond Filter init() called');

    // 綁定事件
    this.bindEvents();

    // 初始化篩選器
    this.initFilters();

    this.updateDiamondLoadMoreVisibility();

    // 確保初始狀態下所有產品都可見
    this.showAllProducts();

    console.log('✅ Diamond Filter ready');
  }

  /**
   * 綁定事件監聽器
   */
  bindEvents() {
    // 使用事件委託處理所有點擊事件
    document.addEventListener('click', (e) => {
      // 視圖切換按鈕
      if (e.target.closest('.view-toggle-btn')) {
        const btn = e.target.closest('.view-toggle-btn');
        const view = btn.dataset.view;
        this.switchView(view);
      }

      // 篩選器 Chip 按鈕
      if (e.target.closest('.filter-chip')) {
        this.handleFilterChipClick(e.target.closest('.filter-chip'));
      }

      // 應用篩選按鈕
      if (e.target.closest('#apply-filters')) {
        this.applyFilters();
      }

      // 重置篩選按鈕
      if (e.target.closest('#reset-filters')) {
        this.resetFilters();
      }

      // Add to cart 按鈕
      if (e.target.closest('.product-add-to-cart-button')) {
        this.handleAddToCart(e.target.closest('.product-add-to-cart-button'));
      }

      // Load More 按鈕
      if (e.target.closest('.load-more-button')) {
        this.handleLoadMore(e.target.closest('.load-more-button'));
      }
    });

    // 初始化範圍滑桿
    this.initRangeSliders();
  }

  /**
   * 切換視圖
   */
  switchView(view) {
    this.currentView = view;

    // 更新按鈕狀態
    document.querySelectorAll('.view-toggle-btn').forEach(btn => {
      btn.classList.toggle('active', btn.dataset.view === view);
    });

    // 切換視圖顯示
    const gridView = document.querySelector('#diamonds-grid');
    const tableView = document.querySelector('#diamonds-table');

    if (gridView && tableView) {
      if (view === 'grid') {
        gridView.style.display = 'grid';
        tableView.style.display = 'none';
      } else {
        gridView.style.display = 'none';
        tableView.style.display = 'block';
      }
    }

    this.updateDiamondLoadMoreVisibility();
  }

  updateDiamondLoadMoreVisibility() {
    const diamondLoadMore = document.querySelector('.diamonds-load-more');
    if (!diamondLoadMore) return;

    diamondLoadMore.style.display = this.currentView === 'grid' ? '' : 'none';
  }

  /**
   * 處理 Filter Chip 點擊
   */
  handleFilterChipClick(chip) {
    console.log('🔍 handleFilterChipClick() called', chip.dataset.value);
    const group = chip.closest('.filter-chips-group');
    const filterType = group.dataset.filter;
    const value = chip.dataset.value;
    const isMultiSelect = group.dataset.multiSelect === 'true';

    // 如果點擊 "All"，取消其他選項
    if (value === '') {
      group.querySelectorAll('.filter-chip').forEach(c => c.classList.remove('active'));
      chip.classList.add('active');
    } else {
      // 取消 "All" 選項
      const allChip = group.querySelector('.filter-chip[data-value=""]');
      if (allChip) allChip.classList.remove('active');

      // 對於多選過濾器，直接切換
      // 對於單選過濾器（shape, color），保持原有邏輯
      if (isMultiSelect) {
        chip.classList.toggle('active');
      } else {
        // 切換當前選項
        chip.classList.toggle('active');

        // 如果沒有任何選項被選中，自動選中 "All"
        const activeChips = group.querySelectorAll('.filter-chip.active:not([data-value=""])');
        if (activeChips.length === 0 && allChip) {
          allChip.classList.add('active');
        }
      }
    }
  }

  /**
   * 初始化範圍滑桿
   */
  initRangeSliders() {
    // 克拉範圍滑桿
    const caratMin = document.querySelector('#filter-carat-min');
    const caratMax = document.querySelector('#filter-carat-max');
    const caratValue = document.querySelector('#carat-range-value');

    if (caratMin && caratMax && caratValue) {
      const updateCaratRange = () => {
        const min = parseFloat(caratMin.value);
        const max = parseFloat(caratMax.value);

        if (min > max) {
          caratMin.value = max;
        }

        caratValue.textContent = `${caratMin.value} - ${caratMax.value} ct`;
      };

      caratMin.addEventListener('input', updateCaratRange);
      caratMax.addEventListener('input', updateCaratRange);
    }

    // 價格範圍滑桿
    const priceMin = document.querySelector('#filter-price-min');
    const priceMax = document.querySelector('#filter-price-max');
    const priceValue = document.querySelector('#price-range-value');

    if (priceMin && priceMax && priceValue) {
      const updatePriceRange = () => {
        const min = parseInt(priceMin.value);
        const max = parseInt(priceMax.value);

        if (min > max) {
          priceMin.value = max;
        }

        priceValue.textContent = `$${parseInt(priceMin.value).toLocaleString()} - $${parseInt(priceMax.value).toLocaleString()}`;
      };

      priceMin.addEventListener('input', updatePriceRange);
      priceMax.addEventListener('input', updatePriceRange);
    }
  }

  /**
   * 綁定 Range Slider 和 Select 的雙向同步 (DEPRECATED - 不再使用)
   */
  bindSelectRangeSlider(filterName) {
    const minSlider = document.querySelector(`#filter-${filterName}-min`);
    const maxSlider = document.querySelector(`#filter-${filterName}-max`);
    const minSelect = document.querySelector(`#filter-${filterName}-min-select`);
    const maxSelect = document.querySelector(`#filter-${filterName}-max-select`);

    if (!minSlider || !maxSlider || !minSelect || !maxSelect) return;

    // Slider 改變時更新 Select
    minSlider.addEventListener('input', () => {
      minSelect.value = minSlider.value;
      this.updateRangeDisplay(filterName);
    });

    maxSlider.addEventListener('input', () => {
      maxSelect.value = maxSlider.value;
      this.updateRangeDisplay(filterName);
    });

    // Select 改變時更新 Slider
    minSelect.addEventListener('change', () => {
      minSlider.value = minSelect.value;
      this.updateRangeDisplay(filterName);
    });

    maxSelect.addEventListener('change', () => {
      maxSlider.value = maxSelect.value;
      this.updateRangeDisplay(filterName);
    });

    // 初始化顯示
    this.updateRangeDisplay(filterName);
  }

  /**
   * 更新範圍顯示文字
   */
  updateRangeDisplay(filterName) {
    const minSelect = document.querySelector(`#filter-${filterName}-min-select`);
    const maxSelect = document.querySelector(`#filter-${filterName}-max-select`);
    const display = document.querySelector(`#${filterName}-range-value`);

    if (minSelect && maxSelect && display) {
      const minText = minSelect.options[minSelect.selectedIndex].text;
      const maxText = maxSelect.options[maxSelect.selectedIndex].text;
      display.textContent = `${minText} - ${maxText}`;
    }
  }

  /**
   * 初始化篩選器
   */
  initFilters() {
    // 克拉範圍滑桿
    const caratMin = document.querySelector('#filter-carat-min');
    const caratMax = document.querySelector('#filter-carat-max');
    const caratValue = document.querySelector('#carat-range-value');

    if (caratMin && caratMax && caratValue) {
      const updateCaratRange = () => {
        const min = parseFloat(caratMin.value);
        const max = parseFloat(caratMax.value);

        if (min > max) {
          caratMin.value = max;
        }

        caratValue.textContent = `${caratMin.value} - ${caratMax.value}`;
      };

      caratMin.addEventListener('input', updateCaratRange);
      caratMax.addEventListener('input', updateCaratRange);
    }

    // 價格範圍滑桿
    const priceMin = document.querySelector('#filter-price-min');
    const priceMax = document.querySelector('#filter-price-max');
    const priceValue = document.querySelector('#price-range-value');

    if (priceMin && priceMax && priceValue) {
      const updatePriceRange = () => {
        const min = parseInt(priceMin.value);
        const max = parseInt(priceMax.value);

        if (min > max) {
          priceMin.value = max;
        }

        priceValue.textContent = `$${parseInt(priceMin.value).toLocaleString()} - $${parseInt(priceMax.value).toLocaleString()}`;
      };

      priceMin.addEventListener('input', updatePriceRange);
      priceMax.addEventListener('input', updatePriceRange);
    }
  }

  /**
   * 顯示所有產品（初始狀態）
   */
  showAllProducts() {
    // 顯示所有網格視圖產品
    const gridProducts = document.querySelectorAll('#diamonds-grid .ring-builder-product-card');
    gridProducts.forEach(product => {
      product.style.display = 'flex';
    });

    // 顯示所有表格視圖產品
    const tableRows = document.querySelectorAll('#diamonds-table-body .diamond-table-row');
    tableRows.forEach(row => {
      row.style.display = '';
    });

    // 移除空狀態訊息
    const emptyStates = document.querySelectorAll('.empty-state');
    emptyStates.forEach(state => {
      if (state.textContent.includes('No diamonds match')) {
        state.remove();
      }
    });
  }

  /**
   * 應用篩選
   */
  applyFilters() {
    console.log('🔍 applyFilters() called');
    const filters = this.getFilterValues();
    console.log('🔍 Filter values:', filters);

    if (this.currentView === 'grid') {
      // Grid 視圖篩選
      const products = document.querySelectorAll('#diamonds-grid .ring-builder-product-card');
      console.log('🔍 Found products in grid:', products.length);
      let visibleCount = 0;

      products.forEach((product, index) => {
        const shouldShow = this.matchesFilters(product, filters);
        if (index < 3) {
          console.log(`🔍 Product ${index}:`, {
            shape: product.dataset.shape,
            color: product.dataset.color,
            clarity: product.dataset.clarity,
            shouldShow: shouldShow,
            beforeDisplay: product.style.display
          });
        }
        product.style.display = shouldShow ? 'flex' : 'none';
        if (index < 3) {
          console.log(`  → afterDisplay: ${product.style.display}`);
        }
        if (shouldShow) visibleCount++;
      });

      console.log('🔍 Visible products after filter:', visibleCount);
      this.updateEmptyState('#diamonds-grid', visibleCount);
    } else {
      // Table 視圖篩選
      const rows = document.querySelectorAll('#diamonds-table-body .diamond-table-row');
      console.log('🔍 Found rows in table:', rows.length);
      let visibleCount = 0;

      rows.forEach(row => {
        const shouldShow = this.matchesFilters(row, filters);
        row.style.display = shouldShow ? '' : 'none';
        if (shouldShow) visibleCount++;
      });

      console.log('🔍 Visible rows after filter:', visibleCount);
      this.updateEmptyState('#diamonds-table-body', visibleCount);
    }

    // 顯示已選擇的篩選標籤
    this.showActiveFilters(filters);
  }

  /**
   * 更新空狀態顯示
   */
  updateEmptyState(containerSelector, visibleCount) {
    const container = document.querySelector(containerSelector);
    if (!container) return;

    let emptyState = container.querySelector('.empty-state');

    if (visibleCount === 0) {
      if (!emptyState) {
        emptyState = document.createElement('div');
        emptyState.className = 'empty-state';
        if (containerSelector.includes('table')) {
          const tr = document.createElement('tr');
          const td = document.createElement('td');
          td.colSpan = 12;
          td.className = 'empty-state';
          td.innerHTML = '<p>No diamonds match your filters. Please adjust your criteria.</p>';
          tr.appendChild(td);
          container.appendChild(tr);
        } else {
          emptyState.innerHTML = '<p>No diamonds match your filters. Please adjust your criteria.</p>';
          container.appendChild(emptyState);
        }
      }
    } else {
      if (emptyState) {
        if (containerSelector.includes('table')) {
          emptyState.closest('tr')?.remove();
        } else {
          emptyState.remove();
        }
      }
    }
  }

  /**
   * 獲取篩選器的值
   */
  getFilterValues() {
    return {
      shape: this.getChipValues('[data-filter="shape"]'),
      caratMin: parseFloat(document.querySelector('#filter-carat-min')?.value || 0.01),
      caratMax: parseFloat(document.querySelector('#filter-carat-max')?.value || 10),
      color: this.getChipValues('[data-filter="color"]'),
      clarity: this.getChipValues('[data-filter="clarity"]'),
      cut: this.getChipValues('[data-filter="cut"]'),
      polish: this.getChipValues('[data-filter="polish"]'),
      symmetry: this.getChipValues('[data-filter="symmetry"]'),
      fluorescence: this.getChipValues('[data-filter="fluorescence"]'),
      priceMin: parseInt(document.querySelector('#filter-price-min')?.value || 0),
      priceMax: parseInt(document.querySelector('#filter-price-max')?.value || 999999),
      certificate: this.getChipValues('[data-filter="certificate"]')
    };
  }

  /**
   * 獲取 Chip 篩選器的值
   */
  getChipValues(selector) {
    const group = document.querySelector(selector);
    if (!group) return [];

    const activeChips = group.querySelectorAll('.filter-chip.active:not([data-value=""])');
    const values = Array.from(activeChips).map(chip => chip.dataset.value.toLowerCase());
    console.log(`🔍 getChipValues(${selector}):`, values);
    return values;
  }

  /**
   * 檢查產品是否符合篩選條件
   */
  matchesFilters(element, filters) {
    // 獲取產品屬性 - 全部轉為小寫以匹配 data 屬性和 filter values
    const shape = (element.dataset.shape || '').toLowerCase();
    const carat = parseFloat(element.dataset.carat) || 0;
    const color = (element.dataset.color || '').toLowerCase();
    const clarity = (element.dataset.clarity || '').toLowerCase();
    const cut = (element.dataset.cut || '').toLowerCase();
    const polish = (element.dataset.polish || '').toLowerCase();
    const symmetry = (element.dataset.symmetry || '').toLowerCase();
    const fluorescence = (element.dataset.fluorescence || '').toLowerCase();
    const price = parseInt(element.dataset.price) || 0;
    const certificate = (element.dataset.certificate || '').toLowerCase();

    // 如果產品沒有任何鑽石屬性（metafields 未設定），則顯示產品
    const hasAnyAttribute = shape || carat > 0 || color || clarity || cut || polish || symmetry || fluorescence || certificate;

    if (!hasAnyAttribute) {
      return true; // 顯示沒有屬性的產品
    }

    // 檢查形狀
    if (filters.shape.length > 0 && shape && !filters.shape.includes(shape)) {
      return false;
    }

    // 檢查克拉
    if (carat > 0 && (carat < filters.caratMin || carat > filters.caratMax)) {
      return false;
    }

    // 檢查顏色
    if (filters.color.length > 0 && color && !filters.color.includes(color)) {
      return false;
    }

    // 檢查淨度 - 使用 array-based 篩選
    if (filters.clarity.length > 0 && clarity && !filters.clarity.includes(clarity)) {
      return false;
    }

    // 檢查切工 - 使用 array-based 篩選
    if (filters.cut.length > 0 && cut) {
      // Normalize cut value for comparison
      const normalizedCut = cut.toLowerCase().trim();
      const normalizedFilters = filters.cut.map(c => c.toLowerCase().trim());
      if (!normalizedFilters.includes(normalizedCut)) {
        return false;
      }
    }

    // 檢查 Polish - 使用 array-based 篩選
    if (filters.polish.length > 0 && polish) {
      const normalizedPolish = polish.toLowerCase().trim();
      const normalizedFilters = filters.polish.map(p => p.toLowerCase().trim());
      if (!normalizedFilters.includes(normalizedPolish)) {
        return false;
      }
    }

    // 檢查 Symmetry - 使用 array-based 篩選
    if (filters.symmetry.length > 0 && symmetry) {
      const normalizedSymmetry = symmetry.toLowerCase().trim();
      const normalizedFilters = filters.symmetry.map(s => s.toLowerCase().trim());
      if (!normalizedFilters.includes(normalizedSymmetry)) {
        return false;
      }
    }

    // 檢查 Fluorescence - 使用 array-based 篩選
    if (filters.fluorescence.length > 0 && fluorescence) {
      const normalizedFluorescence = fluorescence.toLowerCase().trim();
      const normalizedFilters = filters.fluorescence.map(f => f.toLowerCase().trim());
      if (!normalizedFilters.includes(normalizedFluorescence)) {
        return false;
      }
    }

    // 檢查價格（只有當價格大於0時才檢查）
    if (price > 0) {
      const priceInCents = price;
      const priceMinInCents = filters.priceMin * 100;
      const priceMaxInCents = filters.priceMax * 100;
      if (priceInCents < priceMinInCents || priceInCents > priceMaxInCents) {
        return false;
      }
    }

    // 檢查證書（只有當有證書篩選且產品有證書時才檢查）
    if (filters.certificate.length > 0 && certificate && !filters.certificate.includes(certificate)) {
      return false;
    }

    return true;
  }

  /**
   * 將 Clarity 值轉換為數字索引
   */
  getClarityIndex(clarity) {
    const clarityMap = {
      'fl': 0, 'if': 1, 'vvs1': 2, 'vvs2': 3, 'vs1': 4, 'vs2': 5,
      'si1': 6, 'si2': 7, 'i1': 8, 'i2': 9, 'i3': 10
    };
    return clarityMap[clarity.toLowerCase()] ?? -1;
  }

  /**
   * 將 Cut/Polish/Symmetry 值轉換為數字索引
   */
  getQualityIndex(quality) {
    const qualityMap = {
      'fair': 0, 'good': 1, 'very-good': 2, 'very good': 2, 'excellent': 3
    };
    return qualityMap[quality.toLowerCase()] ?? -1;
  }

  /**
   * 將 Fluorescence 值轉換為數字索引
   */
  getFluorescenceIndex(fluorescence) {
    const fluorescenceMap = {
      'none': 0, 'faint': 1, 'medium': 2, 'strong': 3, 'very-strong': 4, 'very strong': 4
    };
    return fluorescenceMap[fluorescence.toLowerCase()] ?? -1;
  }

  /**
   * 顯示已選擇的篩選標籤
   */
  showActiveFilters(filters) {
    // 這個方法可以用來顯示已選擇的篩選條件
    // 目前保留為空，可以根據需要實現
  }

  /**
   * 重置篩選器
   */
  resetFilters() {
    // 重置所有 chip 按鈕
    document.querySelectorAll('.filter-chip').forEach(chip => {
      chip.classList.remove('active');
    });

    // 重置克拉範圍
    const caratMin = document.querySelector('#filter-carat-min');
    const caratMax = document.querySelector('#filter-carat-max');
    if (caratMin) caratMin.value = 0.01;
    if (caratMax) caratMax.value = 10;

    // 重置價格範圍
    const priceMin = document.querySelector('#filter-price-min');
    const priceMax = document.querySelector('#filter-price-max');
    if (priceMin) priceMin.value = 0;
    if (priceMax) priceMax.value = 50000;

    // 重置所有 range slider
    ['clarity', 'cut', 'polish', 'symmetry', 'fluorescence'].forEach(filterName => {
      const minSlider = document.querySelector(`#filter-${filterName}-min`);
      const maxSlider = document.querySelector(`#filter-${filterName}-max`);
      const minSelect = document.querySelector(`#filter-${filterName}-min-select`);
      const maxSelect = document.querySelector(`#filter-${filterName}-max-select`);

      if (minSlider && maxSlider && minSelect && maxSelect) {
        minSlider.value = minSlider.min;
        maxSlider.value = maxSlider.max;
        minSelect.value = minSlider.min;
        maxSelect.value = maxSlider.max;
        this.updateRangeDisplay(filterName);
      }
    });

    // 顯示所有產品
    this.showAllProducts();
  }

  /**
   * 處理加入購物車
   */
  async handleAddToCart(button) {
    const productId = button.dataset.productId;
    const variantId = button.dataset.variantId;
    const productTitle = button.dataset.productTitle;

    if (!variantId) {
      console.error('No variant ID found');
      return;
    }

    // 禁用按鈕並顯示載入狀態
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      // 使用 FormData 而不是 JSON
      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error('Cart API error:', errorData);
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      const data = await response.json();
      console.log('Added to cart:', data);

      // 獲取最新的購物車資訊
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      // 顯示成功訊息
      button.textContent = 'Added!';
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 2000);

      // 觸發主題的 CartAddEvent 事件
      // 這會自動更新購物車圖標並打開 cart drawer（如果啟用了 auto-open）
      const cartAddEvent = new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'diamond-filter',
          data: {
            source: 'diamond-filter',
            itemCount: 1,
            productId: productId,
            variantId: variantId,
            sections: data.sections || {}
          }
        }
      });

      document.dispatchEvent(cartAddEvent);
      console.log('✅ Cart update event dispatched');

    } catch (error) {
      console.error('Error adding to cart:', error);
      alert(`Failed to add product to cart: ${error.message}`);
      button.textContent = originalText;
      button.disabled = false;
    }
  }

  /**
   * 處理載入更多
   */
  async handleLoadMore(button) {
    const collectionHandle = button.dataset.collection;
    const currentPage = parseInt(button.dataset.page) || 1;
    const nextPage = currentPage + 1;
    const productType = button.dataset.type; // 'diamonds'

    // 禁用按鈕，防止重複點擊
    button.disabled = true;
    const originalText = button.textContent;
    button.textContent = 'Loading...';

    try {
      // 獲取當前 section 的設置
      const section = document.querySelector('.diamond-filter-section');
      const productsPerPage = parseInt(section?.dataset.productsPerPage) || 12;

      // 只支持 Grid 視圖的 Load More
      // Table 視圖需要 metafields，但 Products JSON API 不返回 metafields
      if (this.currentView !== 'grid') {
        console.warn('Load More is only supported for Grid view');
        button.parentElement.style.display = 'none';
        return;
      }

      // 獲取 collection 的所有產品
      const collectionUrl = `/collections/${collectionHandle}/products.json?page=${nextPage}&limit=${productsPerPage}`;
      const productsResponse = await fetch(collectionUrl);

      if (!productsResponse.ok) {
        throw new Error(`Failed to fetch products: ${productsResponse.status}`);
      }

      const productsData = await productsResponse.json();
      const products = productsData.products;

      if (products.length > 0) {
        // Grid 視圖 - 添加產品卡片
        const targetGrid = document.getElementById('diamonds-grid');

        if (!targetGrid) {
          throw new Error('Target grid not found');
        }

        for (const product of products) {
          const card = this.createProductCard(product);
          targetGrid.appendChild(card);
        }

        // 更新頁碼
        button.dataset.page = nextPage;

        // 檢查是否還有更多產品
        if (products.length < productsPerPage) {
          // 沒有更多產品了，隱藏按鈕
          button.parentElement.style.display = 'none';
        }
      } else {
        // 沒有找到產品，隱藏按鈕
        button.parentElement.style.display = 'none';
      }

    } catch (error) {
      console.error('Error loading more products:', error);
      alert(`Failed to load more products: ${error.message}`);
    } finally {
      // 恢復按鈕狀態
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  /**
   * 創建產品卡片 DOM 元素（用於 Grid 視圖）
   */
  createProductCard(product) {
    const card = document.createElement('div');
    card.className = 'ring-builder-product-card';
    card.dataset.productId = product.id;
    card.dataset.productType = 'diamond';
    card.dataset.productHandle = product.handle;

    // 獲取 metafields
    const custom = product.metafields?.custom || {};
    if (custom.shape) card.dataset.shape = custom.shape.toLowerCase();
    if (custom.carat) card.dataset.carat = custom.carat;
    if (custom.color) card.dataset.color = custom.color.toLowerCase();
    if (custom.clarity) card.dataset.clarity = custom.clarity.toLowerCase();
    if (custom.cut) card.dataset.cut = custom.cut.toLowerCase();
    if (custom.polish) card.dataset.polish = custom.polish.toLowerCase();
    if (custom.symmetry) card.dataset.symmetry = custom.symmetry.toLowerCase();
    if (custom.fluorescence) card.dataset.fluorescence = custom.fluorescence.toLowerCase();
    if (custom.certificate) card.dataset.certificate = custom.certificate.toLowerCase();
    card.dataset.price = product.variants[0]?.price || 0;

    // 獲取圖片
    const image = product.images[0];
    const imageUrl = image ? image.src.replace(/\.jpg|\.png|\.gif/, '_400x400$&') : '';
    const fallbackLogo = 'https://cdn.shopify.com/s/files/1/0683/2763/7057/files/DC_Logo_2021_FINAL_Blue.webp?v=1764138640';
    const finalImageUrl = imageUrl || fallbackLogo;

    // 格式化價格
    const priceString = product.variants[0]?.price || '0';
    const priceValue = typeof priceString === 'string' ? parseFloat(priceString) : priceString;
    const formattedPrice = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(priceValue);

    // 創建卡片 HTML
    card.innerHTML = `
      <div class="product-card-image">
        <a href="/products/${product.handle}" class="product-image-link">
          <img src="${finalImageUrl}"
               alt="${product.title}"
               loading="lazy"
               width="400"
               height="400"
               class="${imageUrl ? '' : 'product-image-fallback'}">
        </a>
      </div>
      <div class="product-card-info">
        <h3 class="product-title">
          <a href="/products/${product.handle}">${product.title}</a>
        </h3>
        <div class="product-price">
          <span class="price-regular">${formattedPrice}</span>
        </div>
        <button type="button"
                class="button button-primary product-add-to-cart-button"
                data-product-id="${product.id}"
                data-variant-id="${product.variants[0]?.id}">
          Add to cart
        </button>
      </div>
    `;

    return card;
  }

}

// 初始化 Diamond Filter
console.log('🔍 Diamond Filter script loaded');
document.addEventListener('DOMContentLoaded', () => {
  console.log('🔍 DOMContentLoaded fired');
  const section = document.querySelector('.diamond-filter-section');
  console.log('🔍 Diamond filter section found:', !!section);
  if (section) {
    window.diamondFilter = new DiamondFilter();
    console.log('✅ Diamond Filter instance created');
  } else {
    console.log('❌ No .diamond-filter-section found on page');
  }
});


